// extracted by mini-css-extract-plugin
export var button = "button-module--button--BrU2j";
export var outlined = "button-module--outlined--FeTYS";